import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import CampaignBookingsGraph from './CampaignBookingsGraph';
import Code from 'components/ui/show/Code';
import Column from 'components/ui/show/Column';
import DeleteModalButton from 'components/button/DeleteModalButton';
import EditButton from 'components/button/EditButton';
import Header from 'components/ui/general/Header';
import InnerColumn from 'components/ui/show/InnerColumn';
import Section from 'components/ui/general/Section';
import Tab from 'components/tabs/Tab';
import Tabs from 'components/tabs/Tabs';
import TextField from 'components/ui/general/TextField';
import Title from 'components/ui/general/Title';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import { ImageIcon } from 'assets/materialIcons/materialIcons';
import { deleteCampaignFailure, deleteCampaignSuccess } from 'store/actions/campaigns/deleteCampaigns';

class CampaignsShow extends React.Component {
    render() {
        const {
            id,
            record,
            resource,
            translate,
        } = this.props;

        const breadcrumbs = [
            {
                label: translate('resources.campaigns.title'),
                link: '/campaigns',
            },
            {
                label: record.name,
            },
        ];

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs } />

                <Header>
                    <Title title={ record.name }/>

                    <Actions>
                        <EditButton
                            icon={ <ImageIcon color={ theme.palette.doveGray } /> }
                            primary={ false }
                            record={ record }
                            url={ `/${ resource }/${ id }` }
                        />

                        <DeleteModalButton
                            successAction={ deleteCampaignSuccess }
                            failureAction={ deleteCampaignFailure }
                            id={ id }
                            resource='funnels'
                        />
                    </Actions>
                </Header>

                <Section>
                    <Column>
                        <InnerColumn>
                            <CampaignBookingsGraph id={ id } />
                        </InnerColumn>
                    </Column>
                </Section>

                <Title
                    title={ translate('resources.campaigns.show.tabs_title') }
                    style={ {
                        fontSize: '22px',
                    } }
                />
                <Section>
                    <Tabs>
                        <Tab
                            label={ translate('resources.campaigns.show.catalogue') }
                        >
                            <div>
                                <TextField>
                                    { translate('resources.campaigns.show.catalogue_p1') }
                                </TextField>

                                <TextField>
                                    <Code>
                                        {
                                            `https://catalogue.mobian.global/?campaign=${ record.identifier }`
                                        }
                                    </Code>
                                </TextField>

                                <TextField>
                                    { translate('resources.campaigns.show.catalogue_p2') }
                                </TextField>

                                <TextField>
                                    { translate('resources.campaigns.show.catalogue_p3') }
                                </TextField>
                            </div>
                        </Tab>
                        <Tab
                            label={ translate('resources.campaigns.show.api') }
                        >
                            <div>
                                <TextField>
                                    { translate('resources.campaigns.show.api_p1') }
                                </TextField>

                                <TextField>
                                    { translate('resources.campaigns.show.api_p2') }
                                </TextField>

                                <TextField>
                                    <Code>
                                        { record.id }
                                    </Code>
                                </TextField>

                                <TextField>
                                    { translate('resources.campaigns.show.api_p3') }
                                </TextField>
                            </div>
                        </Tab>
                    </Tabs>
                </Section>
            </div>

        );
    }
}

CampaignsShow.propTypes = {
    id: PropTypes.number,
    record: PropTypes.object,
    resource: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(CampaignsShow);



// WEBPACK FOOTER //
// ./src/pages/campaigns/show/CampaignsShow.js